import { Inject, Injectable, forwardRef} from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';

import  { Observable } from 'rxjs/Observable';

import { HttpClient } from './http-client.service';

import { GoalCategory } from '../../entities/goal-category';

import { Settings } from '../../settings';

import { DateConverter } from '../../utility/date-converter';

import { ODataBuilder } from '../../utility/odata/odata-builder';
import { ODataComparer } from '../../utility/odata/odata-comparer';

import { CachedCallService } from './cached-call.service';

@Injectable()
export class GoalCategoryService {
  private readonly headers:Headers = new Headers({ 'Content-Type': 'application/json' });
  private readonly options:RequestOptions = new RequestOptions({ headers: this.headers });

  private static readonly goalCategoryBaseUrl:string = `${Settings.apiUrl}/v1/GoalCategories`;

  protected cachedCallService:CachedCallService = new CachedCallService();

  public goalCategories:GoalCategory[] = [];

  constructor(@Inject(forwardRef(() => HttpClient)) private http:HttpClient) { }

  getGoalCategories(): Promise<GoalCategory[]> {

    let oDataBuilder: ODataBuilder = new ODataBuilder(GoalCategoryService.goalCategoryBaseUrl);

    oDataBuilder
      .orderBy("SortOrder");

    let goalCategoryUrl: string = oDataBuilder.toString();

    return this.http.get(goalCategoryUrl)
      .toPromise()
      .then(response => {
        //I'm using "any" and not GoalCategory because GoalCategory thinks that 
        //StartDate and EndDate are already dates, but they are not yet
        let formattedResponse: any[] = response.json().value;

        formattedResponse.forEach(goalCategory => {
          goalCategory.StartDate = DateConverter.convertDate(goalCategory.StartDate).toISOString();
          goalCategory.EndDate = DateConverter.convertDate(goalCategory.EndDate).toISOString();
        });

        this.goalCategories = formattedResponse;

        return formattedResponse;
      });

  }

  createGoalCategory(goalCategory: GoalCategory): Promise<GoalCategory> {   
    // must remove - breaks deserialization on the server when trying to convert empty string to Guid 
    delete goalCategory.GoalCategoryId;

    return this.http.post(GoalCategoryService.goalCategoryBaseUrl, JSON.stringify(goalCategory), this.options)
      .toPromise()
      .then(response => {
        return response.json();
      });
  }

  patchGoalCategory(goalCategory: GoalCategory): Promise<null> {

    let goalCategoryUrl: string = `${Settings.apiUrl}/v1/GoalCategories(${goalCategory.GoalCategoryId})`;

    return this.http.patch(goalCategoryUrl, JSON.stringify(goalCategory), this.options)
      .toPromise()
      .then(response => response);
  }

  deleteGoalCategory(goalCategoryId: string): Promise<null> {

    let goalCategoryUrl: string = `${Settings.apiUrl}/v1/GoalCategories(${goalCategoryId})`;

    return this.http.delete(goalCategoryUrl, this.options)
      .toPromise()
      .then(response => response);
  }
} 



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/http/goal-category.service.ts